import ENV from '../constants/Env';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useStyles } from '../components/rides/rideFormStyles';
import MainLayout from '../components/layout/MainLayout';
import { useSessionContext } from '../contexts/session-context';

export function CreatePortalRide() {
  const { session } = useSessionContext();
  const history = useHistory();
  const classes = useStyles();
  const { type, riderId } = useParams<{ type: string; riderId: string }>();
  const { search } = useLocation();
  const encounterId =
    new URLSearchParams(search).get('ehrEncounterId') ?? undefined;

  const redirectUrl = new URL(`/rides/new/${type}`, ENV.portalUrl);
  redirectUrl.searchParams.set('embeddedInDashboard', 'true');

  if (riderId) {
    redirectUrl.searchParams.set('riderId', riderId);
  }

  if (encounterId) {
    redirectUrl.searchParams.set('ehrEncounterId', encounterId);
  }

  const portalBookFeatureFlag = session?.featureFlags?.includes(
    'dashboard_portal_book_ride',
  );

  useEffect(() => {
    // Only redirect when featureFlags are loaded (not undefined)
    if (session?.featureFlags && !portalBookFeatureFlag) {
      history.replace({ pathname: '/' });
    }
  }, [portalBookFeatureFlag, session?.featureFlags, history]);

  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="Portal Ride Booking"
        src={redirectUrl.toString()}
        className={classes.iframe}
      />
    </MainLayout>
  );
}
